<template>
  <div>
    <h2 class="step-name">Review Reproduction</h2>

    <div class="step-section">
      <h3> % cows wintered that were Metrichecked/Metricleaned</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Percent of CW Metrichecked</th>
            <th>Region Avg. Percent of CW Metrichecked</th>
            <th>Percent Metricleaned of Metrichecked</th>
            <th>Region Avg. Percent Metricleaned of Metrichecked</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in model.CHARTS.metri_checked_cleaned" :key="index"
            :class="getRowClass(model.CHARTS.metri_checked_cleaned, 'Season', index)">

            <td class="text-left">{{ rv["Season"] }}</td>
            <td class="text-left">{{ rv["Percent of CW Metrichecked"] }}</td>
            <td class="text-left">{{ rv["Region Avg. Percent of CW Metrichecked"] }}</td>
            <td class="text-left">{{ rv["Percent Metricleaned of Metrichecked"] }}</td>
            <td class="text-left">{{ rv["Region Avg. Percent Metricleaned of Metrichecked"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <bar :chart-data="metriCheckedCleanedChartData" :options="defaultChartOptions" ></bar>
    </div>

    <div class="step-section">
      <h3>Dairy Metricheck/Metriclean Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Date</th>
            <th>Product</th>
            <th>Cows</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in model.CHARTS.sr_metri_checked_cleaned_table" :key="index"
            :class="getRowClass(model.CHARTS.sr_metri_checked_cleaned_table, 'Season', index)">

            <td class="text-left">{{ rv["Season"] }}</td>
            <td class="text-left">{{ rv["Date"] }}</td>
            <td class="text-left">{{ rv["Product"] }}</td>
            <td class="text-left">{{ rv["Cows"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3> Dairy cow non—cycling examinations as a percentage of total cows wintered </h3>
      <bar :chart-data="nonCyclingChartData" :options="defaultChartOptions" ></bar>
      <p>Previous seasons period 1st Oct – 31st Dec, current season 1st Oct – YTD</p>
    </div>

    <div class="step-section">
      <h3>CIDR cows treated as a percent of total cows wintered</h3>
      <bar :chart-data="cuemateChartData" :options="defaultChartOptions" ></bar>
      <p>Previous seasons period 1st Oct – 31st Dec, current season 1st Oct – YTD</p>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="repro_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.repro_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="repro_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.repro_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'
import Bar from '../../charts/Bar'

export default {
  mixins: [ baseComponent ],
  components: {
    Bar,
  },
  data() {
    return {
      model: {
        repro_keypoints: "",
        repro_actions: "",
        CHARTS: {
          metri_checked_cleaned: [],
          non_cycling_exam: [],
          cuemate_cidr_treated: [],
          vfd_product_cows_season: [],
          metriclean_product_cows_season: [],
        },
      },
    }
  },
  computed: {
    defaultChartOptions: function () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Percent of CW',
            }
          }]
        }
      }
    },
    cuemateChartData: function () {
      return {
        labels: this.model.CHARTS.cuemate_cidr_treated.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.cuemate_cidr_treated.map(row => row['Percent treated of CW']).reverse(),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.cuemate_cidr_treated.map(row => row['Region Avg. Percent treated of CW']).reverse(),
          },
        ],
      }
    },
    nonCyclingChartData: function() {
      return {
        labels: this.model.CHARTS.non_cycling_exam.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.non_cycling_exam.map(row => row['Percent examined of CW']).reverse(),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.non_cycling_exam.map(row => row['Region Avg. Percent examined of CW']).reverse(),
          },
        ],
      }
    },
    metriCheckedCleanedChartData: function() {
      return {
        labels: this.model.CHARTS.metri_checked_cleaned.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "Percent of CW Metrichecked",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Percent of CW Metrichecked']).reverse(),
          },
          {
            label: "Percent Metricleaned of Metrichecked",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Percent Metricleaned of Metrichecked']).reverse(),
          },
          {
            label: "Region Avg. Percent of CW Metrichecked",
            backgroundColor:  "#ADFF2F",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Region Avg. Percent of CW Metrichecked']).reverse(),
          },
          {
            label: "Region Avg. Percent Metricleaned of Metrichecked",
            backgroundColor:  "#008000",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Region Avg. Percent Metricleaned of Metrichecked']).reverse(),
          },
        ],
      }
    },
  },
};
</script>
